<template>
  <div class="d-flex flex-column">
    <span>{{ timeToEta }}</span>
    <span class="body-2 grey--text text--darken-2">{{
      trip.eta | formatTime
    }}</span>
  </div>
</template>

<script>
import { format, differenceInMinutes } from 'date-fns'

export default {
  name: 'TripETA',

  props: {
    trip: Object
  },

  filters: {
    formatTime: date => format(new Date(date), 'HH:mm')
  },

  data: () => ({
    intervalId: null,
    timeNow: new Date()
  }),

  mounted() {
    const MINUTE = 60 * 1000
    this.intervalId = setInterval(() => {
      this.timeNow = new Date()
    }, MINUTE)
  },
  computed: {
    timeToEta() {
      const minutesToEta = differenceInMinutes(
        new Date(this.trip.eta),
        this.timeNow
      )
      return minutesToEta > 0 ? `${minutesToEta} min` : '-'
    }
  },

  beforeDestroy() {
    clearInterval(this.intervalId)
  }
}
</script>
